// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rules .rule[data-v-2b3b0d20]{border:solid 1px var(--border);padding:20px;margin-bottom:20px;position:relative}", ""]);
// Exports
module.exports = exports;
